export default {"src":"__ASTRO_ASSET_IMAGE__DtPkD9k0__","width":2500,"height":1667,"format":"jpg"}